import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

import { LoadingOverlay, Text } from '../../../../shared/uiComponents';
import { HeaderWrapper } from '../helpers';
import { findSoapNoteTamplate } from '../../../SOAPNote';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { getSessionInfo } from '../../../../redux/State/clientSlice/sessionSlice';

const EditSoapNote = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const { client, date, sessionType } = useSelector((state) => state.session.sessionInfo);
	const supervisor = useSelector((state) => state.soapNote.soapNoteData.supervisor);
	const isLoading = useSelector((state) => state.soapNote.initialLoading);

	useEffect(() => {
		const sessionId = params.get('sessionId');
		if (!sessionId) return;

		dispatch(getSessionInfo(sessionId));
	}, [params, dispatch]);

	return (
		<>
			<LoadingOverlay open={isLoading} title="Loading SOAP Note..." />
			<div className="container" style={{ flexDirection: 'column', maxWidth: '900px' }}>
				<HeaderWrapper className="title marginBottom16">
					<Text title="SOAP Note" type="h1" font="header" fontWeight="semiBold" />
					{Boolean(date) && <Text title={`Date: ${dayjs(date).format('MM/DD/YYYY')}`} fontWeight="semiBold" />}
					{Boolean(client) && <Text title={client.fullName} type="plg" fontWeight="semiBold" />}
					{Boolean(supervisor?.id) && (
						<Text title={`Supervisor: ${supervisor?.fullName ?? ''}`} type="plg" fontWeight="semiBold" />
					)}
				</HeaderWrapper>
				{Boolean(sessionType.id) && (
					<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
						<Text title="Service: " type="h4" fontWeight="semiBold" />
						<Text title={sessionType.name} type="h4" />
					</div>
				)}
				<div className="marginBottom16" />
				{findSoapNoteTamplate(sessionType.type)}
			</div>
		</>
	);
};

export default EditSoapNote;
